import { createFileRoute } from "@tanstack/react-router";
import AdminNewslettersPage from "@/admin/pages/newsletters";

export const Route = createFileRoute("/admin/newsletters/")({
  component: AdminNewslettersPage,
});
